import { Location } from '@angular/common';
import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GetApplicationsAdmin } from '../../../../../core/shared/actions/admin.actions';
import { Admin } from '../../../../../core/shared/models/admin.model';
import { adminState } from '../../../../../core/shared/states/admin.state';
import { ApplicationAdminModalComponent } from '../../modals/application-admin-modal/application-admin-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-admins-list',
  templateUrl: './admins-list.component.html',
  styleUrls: ['./admins-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    LoadingSpinnerComponent,
    MatInputModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class AdminsListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public dataSource = new MatTableDataSource<Admin>();
  public displayedColumns = ['icon', 'application', 'admin_email', 'Description', 'actions'];
  public loading = true;
  public admin!: Admin;
  public adminCount = 0;
  public applicationName: any;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  public readonly admins: Observable<Admin[]>;

  constructor(
    private store: Store,
    private location: Location,
    private route: ActivatedRoute,
    public modalService: NgbModal
  ) {
    this.applicationName = this.route.snapshot.paramMap.get('Application_Name');
    this.store.dispatch(new GetApplicationsAdmin(this.applicationName));
    this.admins = this.store.select(adminState.getAdminList);
  }

  ngOnInit() {
    this.admins.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource.data = data;
      this.adminCount = data.length;
      this.loading = false;
    });
  }

  openModal(selectedAdmin: Admin, formMode: string, applicationName: string, editApplication: boolean) {
    const modalRef = this.modalService.open(ApplicationAdminModalComponent, { size: 'lg' });
    modalRef.componentInstance.admin = selectedAdmin;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editApplication = editApplication;
    modalRef.componentInstance.formMode = formMode;
  }

  back(): void {
    this.location.back();
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
